import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import swal from "sweetalert";

const DevoteeForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const [qrData, setQrData] = useState({
    user_id: "",
    lat: "",
    lon: "",
    time: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    address: "",
    pinCode: "",
    company: "",
    designation: "",
    email: "",
    mobile: "",
    husbandWife: "",
    childName: "",
    dob: "",
    age: "",
    nativeTown: "",
    ancestralReference: "",
    services: "",
    date: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setQrData({
      user_id: searchParams.get("user_id") || "",
      lat: searchParams.get("lat") || "",
      lon: searchParams.get("lon") || "",
      time: searchParams.get("time") || "",
       filledby: searchParams.get("filledby") || "",    
    filledfor: searchParams.get("filledfor") || "",     
    });
  }, [location.search]);

  const calculateAge = (dob) => {
    if (!dob) return "";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age.toString();
  };

  const validate = () => {
    const newErrors = {};
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Name validation
    if (!formData.name.trim()) newErrors.name = "Name is required";
    
    // Address validation
    if (!formData.address.trim()) newErrors.address = "Address is required";
    
    // Pincode validation (6 digits)
    if (!formData.pinCode.trim()) {
      newErrors.pinCode = "Pin code is required";
    } else if (!/^\d{6}$/.test(formData.pinCode)) {
      newErrors.pinCode = "Pin code must be 6 digits";
    }
    
    // Email validation
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email";
    
    // Mobile validation
    if (!formData.mobile.trim()) newErrors.mobile = "Mobile is required";
    else if (!/^\d{10}$/.test(formData.mobile))
      newErrors.mobile = "Enter valid 10-digit mobile";
    
    // Date of Birth validation
    if (!formData.dob) {
      newErrors.dob = "Date of Birth is required";
    } else {
      const dobDate = new Date(formData.dob);
      if (dobDate > today) {
        newErrors.dob = "Date of Birth cannot be in the future";
      }
    }
    
    // Age validation
    if (!formData.age.trim()) newErrors.age = "Age is required";
    
    // Native town validation
    if (!formData.nativeTown.trim())
      newErrors.nativeTown = "Native town is required";
    
    // Date validation
    if (!formData.date) newErrors.date = "Date is required";

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFormData(prev => {
      const newData = { ...prev, [name]: value };
      
      // Auto-calculate age when DOB changes
      if (name === "dob" && value) {
        newData.age = calculateAge(value);
      }
      
      return newData;
    });

    // Clear error when field changes
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!qrData.user_id.trim()) {
      swal("Error", "User ID is missing from QR data.", "error");
      setIsSubmitting(false);
      return;
    }

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      swal(
        "Validation Failed",
        "Please fill all required fields correctly.",
        "warning"
      );
      setIsSubmitting(false);
      return;
    }

    const fullData = {
      ...formData,
      ...qrData,
    };

    try {
      const res = await fetch("http://induskitchens.com/submitdevotee.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(fullData),
      });

      const result = await res.json();
      setIsSubmitting(false);
      
      if (result.success) {
        swal("Success", "Form submitted successfully!", "success");

        // Reset state
        setFormData({
          name: "",
          address: "",
          pinCode: "",
          company: "",
          designation: "",
          email: "",
          mobile: "",
          husbandWife: "",
          childName: "",
          dob: "",
          age: "",
          nativeTown: "",
          ancestralReference: "",
          services: "",
          date: "",
        });
        setQrData({ user_id: "", lat: "", lon: "", time: "" });
        setErrors({});
      } else {
        swal("Failed", result.error || "Submission failed.", "error");
      }
    } catch (err) {
      setIsSubmitting(false);
      console.error(err);
      swal("Error", "Could not connect to the server.", "error");
    }
  };

  const FullScreenLoader = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100px" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50px"
          height="50px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <circle
            cx="50"
            cy="50"
            fill="none"
            stroke="#3498db"
            strokeWidth="10"
            r="35"
            strokeDasharray="164.93361431346415 56.97787143782138"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              repeatCount="indefinite"
              dur="1s"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
            />
          </circle>
        </svg>
      </div>
    </div>
  );

  return (
    <div
      className="container my-4 p-4 border rounded shadow"
      style={{ maxWidth: "720px" }}
    >
      {isSubmitting && <FullScreenLoader />}
      <h4 className="text-center text-primary mb-3">
        Sri Kanchi Kamakoti Peetam
      </h4>
      <h6 className="text-center text-secondary mb-4">DEVOTEE DATA - CARD</h6>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-12 mb-3">
            <label>Name *</label>
            <input
              type="text"
              name="name"
              className={`form-control ${errors.name && "is-invalid"}`}
              onChange={handleChange}
              value={formData.name}
            />
            <div className="invalid-feedback">{errors.name}</div>
          </div>

          <div className="col-md-12 mb-3">
            <label>Address *</label>
            <textarea
              name="address"
              className={`form-control ${errors.address && "is-invalid"}`}
              rows="2"
              onChange={handleChange}
              value={formData.address}
            />
            <div className="invalid-feedback">{errors.address}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label>Pin Code *</label>
            <input
              type="text"
              name="pinCode"
              className={`form-control ${errors.pinCode && "is-invalid"}`}
              onChange={handleChange}
              value={formData.pinCode}
              maxLength="6"
            />
            <div className="invalid-feedback">{errors.pinCode}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label>Company</label>
            <input
              type="text"
              name="company"
              className="form-control"
              onChange={handleChange}
              value={formData.company}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Designation</label>
            <input
              type="text"
              name="designation"
              className="form-control"
              onChange={handleChange}
              value={formData.designation}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              className={`form-control ${errors.email && "is-invalid"}`}
              onChange={handleChange}
              value={formData.email}
            />
            <div className="invalid-feedback">{errors.email}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label>Mobile *</label>
            <input
              type="text"
              name="mobile"
              className={`form-control ${errors.mobile && "is-invalid"}`}
              onChange={handleChange}
              value={formData.mobile}
              maxLength="10"
            />
            <div className="invalid-feedback">{errors.mobile}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label>Name of Husband / Wife</label>
            <input
              type="text"
              name="husbandWife"
              className="form-control"
              onChange={handleChange}
              value={formData.husbandWife}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Name of Child</label>
            <input
              type="text"
              name="childName"
              className="form-control"
              onChange={handleChange}
              value={formData.childName}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Date of Birth *</label>
            <input
              type="date"
              name="dob"
              className={`form-control ${errors.dob && "is-invalid"}`}
              onChange={handleChange}
              value={formData.dob}
              max={new Date().toISOString().split("T")[0]}
            />
            <div className="invalid-feedback">{errors.dob}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label>Age *</label>
            <input
              type="number"
              name="age"
              className={`form-control ${errors.age && "is-invalid"}`}
              onChange={handleChange}
              value={formData.age}
              readOnly
            />
            <div className="invalid-feedback">{errors.age}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label>Native Town *</label>
            <input
              type="text"
              name="nativeTown"
              className={`form-control ${errors.nativeTown && "is-invalid"}`}
              onChange={handleChange}
              value={formData.nativeTown}
            />
            <div className="invalid-feedback">{errors.nativeTown}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label>Ancestral Reference</label>
            <input
              type="text"
              name="ancestralReference"
              className="form-control"
              onChange={handleChange}
              value={formData.ancestralReference}
            />
          </div>

          <div className="col-md-12 mb-3">
            <label>Services You Would Like to Provide</label>
            <input
              type="text"
              name="services"
              className="form-control"
              onChange={handleChange}
              value={formData.services}
            />
          </div>

          <div className="col-md-6 mb-4">
            <label>Date *</label>
            <input
              type="date"
              name="date"
              className={`form-control ${errors.date && "is-invalid"}`}
              onChange={handleChange}
              value={formData.date}
            />
            <div className="invalid-feedback">{errors.date}</div>
          </div>

          <div className="col-12 text-center">
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={!qrData.user_id.trim() || isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DevoteeForm;